import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { ProspectsIcon } from '../assets';
import { Breadcrumbs } from '../components/common/Breadcrumbs';
import { BrandForm } from '../components/users/brandForm';
import { ROUTES } from '../config/routes/config';
import { GET_PROSPECT } from '../graphql/prospects/query';
import { useNotification } from '../hooks/useNotification';

export const SingleProspect = () => {
  const { id } = useParams();
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const { notifyWarning } = useNotification();
  const { data, refetch } = useQuery(GET_PROSPECT, {
    variables: { brandId: id },
    onError: () => {
      notifyWarning(t('global.errorSingleBrand'));
      navigate(ROUTES.PROSPECTS);
    },
    skip: !id,
  });

  return (
    <div className="w-full flex flex-col gap-y-5">
      {data && data.brand && data.brand.data && (
        <>
          <Breadcrumbs
            icon={<ProspectsIcon />}
            breadcrumbs={[
              {
                text: t('prospects.title'),
                link: ROUTES.PROSPECTS,
              },
              {
                text: data?.brand.data.name || '',
              },
            ]}
          />
          <BrandForm info={data?.brand.data} refetch={refetch} isProspect />
        </>
      )}
    </div>
  );
};
